import { IoMdClose } from "react-icons/io";
interface Propsmodal {
  children: React.ReactNode;
  isActive: Boolean;
  clouse?: () => void;
  title?: string;
  id?: any;
}

const Modal = ({ isActive, children, clouse, title, id }: Propsmodal) => {
  return (
    <div id={id} className={`c-modal ${isActive && `c-modal--visibility`}`}>
      <div className="c-modal__body">
        {isActive && (
          <div className="c-modal__header">
            <span className="c-modal__title">{title}</span>
            <IoMdClose onClick={clouse} />
          </div>
        )}
        <div className="c-modal__content">{children}</div>
      </div>
      <div className="c-modal__footer"></div>
    </div>
  );
};

export default Modal;
